jQuery(function($){
  // $(window).on("load resize scroll",function(){
  //   if( $(document).scrollTop() > ( $(document).height() - bottomOffset ) && canBeLoaded == true ) {
  //     load_products();
  //   }
  // });
  load_products();
});

var canBeLoaded = true,
    bottomOffset = 2000;

function load_products() {
  var data = {
    'action'      : 'get_products',
    'since_id'    : infinity_scroll.since_id,
    'collection'  : infinity_scroll.collection
  };

  $.ajax({
    url         : infinity_scroll.ajaxurl,
    data        : data,
    dataType    : 'json',
    type        : 'POST',
    beforeSend  : function( xhr ) {
      canBeLoaded = false;
    },
    success     : function(data) {
      if( data.product_list ) {
        $('.store__items').append( data.product_list );
        canBeLoaded = true;
        // infinity_scroll.since_id = data.since_id;
      }
    },
    complete    : function () {
      setCardBackgroundImage();
    }
  });
}

$(document).on('click', '.store__category', function() {
  // Get collection id
  infinity_scroll.collection = $(this).data('id');

  // Clear item listings
  $('.store__items').html('');

  // Reset since id, so we can go back from the first item
  // infinity_scroll.since_id = 0;

  // Fetch Shopify Products
  load_products();
});

// TODO refactor this to merge with infinity article same function
function setCardBackgroundImage() {
  $('.card__image--as-background').each(function () {
    let imageUrl = $(this).find('img').attr('src');
    $(this).css('background-image', 'url('+ imageUrl + ')' );
  });
}
